import { Job } from './job';
import { JobNode } from './job-node';

export interface NodeJob extends Job {
    nodes?: JobNode[];
}
